import { FaqConfig } from '@app-types/eligibility/config';

import { LegalsSlugType, PAGE_SLUG } from '@helpers/partials';

import { PlanTypeId } from '@constants/plan';
import { ELIGIBILITY_JOURNEY } from '@constants/provider';

import { EligibilityJourneyConfig } from './eligibility-config';

export class PromoPriveeJourneyConfig extends EligibilityJourneyConfig {
    protected readonly name = ELIGIBILITY_JOURNEY.PROMO_PRIVEE;
    protected readonly showComparatorSelection = false;
    protected readonly offerCategoryCodeToShow: PlanTypeId = PlanTypeId.FAI_PROMO_PRIVEE;
    protected readonly accessKeyPartnerConfigKey = 'promoPriveeReferrers';
    protected readonly wordings = {
        mainTitle: 'Testez votre éligibilité et découvrez la promo privée \u00A0!',
        noFiber: "En attendant l'arrivée de la fibre...",
    };
    protected readonly faq: FaqConfig = {
        title: 'Vos questions fréquentes sur l’éligibilité à la fibre',
        path: PAGE_SLUG.PROMO_PRIVEE,
        isHiddenBeforeTest: false,
    };
    protected readonly legalsPath: LegalsSlugType = PAGE_SLUG.PROMO_PRIVEE;
    protected readonly tracking = {
        page: 'Eligibilite_test_promo_privee',
        pageCategory: 'Eligibilite',
        eCommerceStep: '',
        universe: 'Boutique_Fai',
        marketLine: 'Fai',
        variant: {
            type_offres: 'Offres_promo_privee',
        },
        variables: {
            type_offres: 'Offres_promo_privee',
        },
    };
    protected readonly extraCmsBlockByTab = {};
}
